import { Component, OnInit } from '@angular/core';
import { DebounceService } from 'src/app/services/debounce.service'; 
import { WinService } from 'src/app/services/win.service'; 
import { SessionService } from 'src/app/services/session.service';
/*import { SettingsService } from 'src/app/services/site/settings.service';*/
import { CartService } from 'src/app/services/api/cart.service';
import { SocialLoginService } from './services/social-login.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'entrelabel';

  constructor(
    public deb: DebounceService,
    public winService: WinService,
    public sessionService: SessionService,
    public cartService: CartService,
	public socialLoginService: SocialLoginService
    /*public settingsService: SettingsService*/
  ) {}

	ngOnInit() {
		this.sessionService.checkLogin().then(res => {
			// if(res){
			// 	this.cartService.getCartId().then(cartId => {
			// 		this.cartService.getCart();
			// 	});
			// }
		});

		this.cartService.getCartId().then(cartId => {
			this.cartService.getCart();
		});
		var myEfficientFn = this.deb.debounce(f => {
			this.winService.outerWidth = window.outerWidth;
		}, 250);
		
		window.addEventListener('resize', myEfficientFn);
	}
}
